import type { DocumentTemplateVersionPayload } from '@Application/Documents/Templates/Actions/documentTemplateVersionsFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `templateId` is read off the `template` relation (`{ id }`). `updatedAt` and the organization
 * relation are on the wire but never consumed.
 */
class DocumentTemplateVersionView {
	readonly id: number;
	readonly templateId: number;
	readonly versionNumber: number;
	readonly originalFilename: string;
	readonly fieldCount: number;
	readonly createdAt: string;

	constructor(payload: DocumentTemplateVersionPayload) {
		this.id = payload.id;
		this.templateId = payload.template.id;
		this.versionNumber = payload.versionNumber;
		this.originalFilename = payload.originalFilename;
		this.fieldCount = payload.fieldCount;
		this.createdAt = payload.createdAt;

		Object.freeze(this);
	}
}

export default DocumentTemplateVersionView;
